import { gql } from "@apollo/client";

export const GET_SUBSCRIPTION_PLANS = gql`
  query GetSubscriptionPlans {
    subscriptionPlans {
      id
      type
      name
      description
      price
      currency
      billingPeriodMonths
      isActive
      sortOrder
      features
      createdAt
      updatedAt
      limiters {
        id
        type
        name
        limitValue
        period
        isHardLimit
        isActive
      }
    }
  }
`;

export const GET_SUBSCRIPTION_LIMITERS = gql`
  query GetSubscriptionLimiters {
    subscriptionLimiters {
      id
      type
      name
      description
      limitValue
      period
      isActive
      isHardLimit
      subscriptionPlanId
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER_SUBSCRIPTIONS = gql`
  query GetUserSubscriptions {
    adminGetUserSubscriptions {
      id
      status
      startDate
      endDate
      cancelledAt
      renewedAt
      amountPaid
      currency
      paymentTransactionId
      autoRenew
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      subscriptionPlan {
        id
        name
        type
        price
      }
    }
  }
`;

export const GET_SUBSCRIPTION_STATS = gql`
  query GetSubscriptionStats {
    adminGetSubscriptionStats {
      totalPlans
      activePlans
      totalSubscriptions
      activeSubscriptions
      expiredSubscriptions
      cancelledSubscriptions
      planStats {
        planId
        planName
        planType
        totalSubscriptions
        activeSubscriptions
        totalRevenue
      }
    }
  }
`;

export const GET_LIMITER_STATS = gql`
  query GetLimiterStats {
    adminGetLimiterStats {
      limiterType
      totalUsage
      averageUsage
      maxUsage
      usersAtLimit
    }
  }
`;

// Mutations
export const CREATE_SUBSCRIPTION_PLAN = gql`
  mutation CreateSubscriptionPlan($input: CreateSubscriptionPlanInput!) {
    createSubscriptionPlan(input: $input) {
      id
      type
      name
      description
      price
      currency
      billingPeriodMonths
      isActive
      sortOrder
      features
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUBSCRIPTION_PLAN = gql`
  mutation UpdateSubscriptionPlan($input: UpdateSubscriptionPlanInput!) {
    updateSubscriptionPlan(input: $input) {
      id
      type
      name
      description
      price
      currency
      billingPeriodMonths
      isActive
      sortOrder
      features
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_SUBSCRIPTION_PLAN = gql`
  mutation DeleteSubscriptionPlan($id: String!) {
    deleteSubscriptionPlan(id: $id)
  }
`;

export const CREATE_SUBSCRIPTION_LIMITER = gql`
  mutation CreateSubscriptionLimiter($input: CreateSubscriptionLimiterInput!) {
    createSubscriptionLimiter(input: $input) {
      id
      type
      name
      description
      limitValue
      period
      isActive
      isHardLimit
      subscriptionPlanId
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_SUBSCRIPTION_LIMITER = gql`
  mutation UpdateSubscriptionLimiter($input: UpdateSubscriptionLimiterInput!) {
    updateSubscriptionLimiter(input: $input) {
      id
      type
      name
      description
      limitValue
      period
      isActive
      isHardLimit
      subscriptionPlanId
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_SUBSCRIPTION_LIMITER = gql`
  mutation DeleteSubscriptionLimiter($id: String!) {
    deleteSubscriptionLimiter(id: $id)
  }
`;

export const CREATE_USER_SUBSCRIPTION = gql`
  mutation CreateUserSubscription($input: CreateUserSubscriptionInput!) {
    createUserSubscription(input: $input) {
      id
      status
      startDate
      endDate
      amountPaid
      currency
      autoRenew
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      subscriptionPlan {
        id
        name
        type
      }
    }
  }
`;

export const UPDATE_USER_SUBSCRIPTION = gql`
  mutation UpdateUserSubscription($input: UpdateUserSubscriptionInput!) {
    updateUserSubscription(input: $input) {
      id
      status
      startDate
      endDate
      cancelledAt
      renewedAt
      amountPaid
      currency
      autoRenew
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      subscriptionPlan {
        id
        name
        type
      }
    }
  }
`;

export const DELETE_USER_SUBSCRIPTION = gql`
  mutation DeleteUserSubscription($id: String!) {
    deleteUserSubscription(id: $id)
  }
`;
